
<div (click)="close($event)">

  <mat-icon [color]="iconColor">{{icon}}</mat-icon>

  <span [innerHTML]="message"></span>

</div>
